import React from "react";
import { Outlet } from "react-router-dom";

export const AuthLayout = () => {
  // TODO: Implement this
  return (
    <div>
      <Outlet />
    </div>
  );
};
